import { validationConstants } from '../constants'

export const PINActivateUser = (state = {}, action) => {
    switch (action.type) {
        case validationConstants.PINACTIVATEUSER_REQUEST:
            return { loading: true, items: undefined, error: undefined }
            
        case validationConstants.PINACTIVATEUSER_SUCCESS:
            return {
                loading: false,
                items: action.valActivaUserData.Body,
                error: undefined
            }
            
        case validationConstants.PINACTIVATEUSER_FAILURE:
            return { loading: false, items: undefined, error: action.error }
            
        default:
            return state
    }
}

export const VALCAPTCHA = (state = {}, action) => {
    switch (action.type) {
        case validationConstants.VALCAPTCHA_REQUEST:
            return { loading: true, items: undefined, error: undefined }
            
        case validationConstants.VALCAPTCHA_SUCCESS:
            return {
                loading: false,
                items: action.captchaData.Body,
                activeButton: action.captchaData.Body.Success,
                error: undefined
            }
            
        case validationConstants.VALCAPTCHA_FAILURE:
            return { loading: false, items: undefined, error: action.error }
            
        default:
            return state
    }
}

export const ValidateChangPass = (state = {}, action) => {
    switch (action.type) {
        case validationConstants.VALIDATECHANGPASS_REQUEST:
            return { loading: true, items: undefined, error: undefined }
            
        case validationConstants.VALIDATECHANGPASS_SUCCESS:
            return {
                loading: false,
                items: action.valChangPassData.Body,
                error: undefined
            }
            
        case validationConstants.VALIDATECHANGPASS_FAILURE:
            return { loading: false, items: undefined, error: action.error }
            
        default:
            return state
    }
}

export const DocumentValidation = (state = {}, action) => {
    switch (action.type) {
        case validationConstants.VALIDATE_DOC_REQUEST:
            return { loading: true, items: undefined, error: undefined }
            
        case validationConstants.VALIDATE_DOC_SUCCESS:
            return {
                loading: false,
                items: action.valDoc.Body,
                error: undefined
            }
            
        case validationConstants.VALIDATE_DOC_FAILURE:
            return { loading: false, items: undefined, error: action.error }
            
        default:
            return state
    }
}